import StopsPage from './components/StopsPage';

const routes = [
  {
    path: '/stops',
    name: 'menu.stops',
    icon: 'p-square',
    loginRequired: true,
    component: StopsPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
